
/**
 * @name crud_marketing_leads.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_marketing_leads.js
 */

//import { apiCall, getBaseDir } from './utils.js';

const io = require("socket.io-client");
const moment = require("moment-timezone");
const XLSX = require('xlsx');

import TableBuilder from './table_builder.js';
var getBaseDir = null, apiCall = null, userHasRole = null;
import Tagify from "@yaireo/tagify";

$(function () {
    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        userHasRole = utils.userHasRole;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'marketing/leads')
            return;

        new MarketingDashboard(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
            userHasRole: utils.userHasRole,
        });
    });
});

class MarketingDashboard {
    constructor(onloadList = false, deps = {}) {
        let urlParams = new URLSearchParams(window.location.search);
        let viewParameter = 'table';
        if (urlParams.get('view') == 'crm') {
            viewParameter = 'kanban';
        }

        this.deps = deps;
        this.responses = {};
        this.servHealth = false;
        this.ws = false;
        this.onlyFranchise = false;
        this.totalLeadsIntv = false;
        this.businessId = -1;
        this.businessBranches = -1;
        this.allowedBranches = -1;
        this.branchFilter = '';
        this.branchId = -1;
        this.filterLeadType = '';
        this.filterLeadCategoryTypeId = '';
        this.filterLeadTags = '';
        this.leadsCache = [];
        this.leadsTotal = 0;
        this.selectedLeadId = false;
        this.elementsBinded = false;
        this.viewMode = viewParameter; // 'table' | 'kanban'
        this.kanbanColumnsData = {}; // Cache de dados por coluna do kanban
        this.kanbanColumnsPages = {}; // Rastreia página atual de cada coluna do kanban
        this.pendingTagsUpdate = null; // Armazena tags pendentes quando aguarda CPF
        this.isReconnecting = false; // Flag para controlar reconexão
        this.kanbanRendered = false; // Flag para saber se kanban já foi renderizado
        this.wasReconnecting = false; // Flag para saber se está reconectando
        this.bindedElementsChanges = false; // Flag para saber se elementos já foram bindados
        this.isLoadingAllKanbanColumns = false; // Flag para saber se está carregando todas as colunas do kanban
        this.crmMode = 'geral';
        let self = this;

        if (onloadList) {
            apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/leads-tags',
                successCallback: function (res) {
                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        window._sessionData.tags = res.data;
                    }
                },
                errorCallback: function () {
                }
            })

            var intv = setInterval(function () {
                if (!window._sessionData.businessBranches || window._sessionData.tags.length === 0)
                    return;

                clearInterval(intv);

                self.businessId = window._sessionData.businessId;
                self.businessBranches = window._sessionData.businessBranches;
                self.allowedBranches = window._sessionData.businessBranches.map((branch) => {
                    if (!self.deps.userHasRole('ADMIN') && self.deps.userHasRole('MANAGER'))
                        return branch.ID;
                    if (self.deps.userHasRole('ADMIN') && self.onlyFranchise && branch.FRANQUIADO == 1)
                        return branch.ID;
                    if (self.deps.userHasRole('ADMIN') && !self.onlyFranchise && branch.FRANQUIADO == 0)
                        return branch.ID;
                    return false;
                }).filter((branch) => branch !== false);

                console.log(self.allowedBranches);

                self.startWsConnection()
                    .then(() => {
                        console.log('re render hunter meta report')
                    })
                    .then(() => {
                        self.bindedElementsChanges = true;
                        self.bindElementsChanges();
                    })
                    .catch((error) => {
                        console.error('[LEADS API] Error starting WS connection:', error);
                    });
            }, 1000);

            if (viewParameter == 'kanban') {
                viewParameter = 'kanban';

                // Atualizar botões ativos
                $('.js-leads-view-toggle').removeClass('active');
                //$(this).addClass('active');

                $('.js-leads-table-view').addClass('d-none');
                $('.js-leads-kanban-view').removeClass('d-none');
                // Renderizar kanban se ainda não foi renderizado
                if (!self.kanbanRendered || $('.js-leads-kanban-container').children().length === 0) {
                    //self.renderKanbanView();
                }
            }
        }
    }

    startWsConnection() {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-leads-table").block(window._loader.connecting);

            if (!self.tableHandler) {
                self.tableHandler = new TableBuilder({
                    table: '#table-leads-list',
                    tableBody: '.js-leads-list',
                    data: [],
                    rowsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                    filter: false,
                    maxPages: 0,
                    tableRowRenderer: function (rowData) {
                        if (rowData.ATIVO == 1) {
                            return self.mountLeadRow(rowData, {
                                no_tr: false,
                                locked: /*rowData.LEAD_DONO_ID != null && rowData.LEAD_DONO_ID != window._sessionData.userId && self.deps.userHasRole('SELLER') ? true : */false
                            });
                        }
                    }
                });
                self.bindStrategyPaginationPageChange();
            }

            //const server = "https://clinicaleads-j5wtgcou.b4a.run";
            //const server = "https://177.153.60.7:22222";
            const server = "https://ws-leads-api.clinicasajustar.com.br";
            //const server = "http://127.0.0.1:22222";

            this.ws = io(server, {
                reconnection: true,
                transports: ["websocket"],
                rejectUnauthorized: false,
                pingInterval: 1000 * 60 * 5,
                pingTimeout: 1000 * 60 * 3
            });

            this.ws.on("connect", () => {
                if (!self.bindedElementsChanges) {
                    self.bindedElementsChanges = true;
                    self.bindElementsChanges();
                }
                self.servHealth = true;
                self.wasReconnecting = self.isReconnecting;
                self.isReconnecting = false;

                console.log('[LEADS API] Successfully connected to Leads WS API.' + (self.wasReconnecting ? ' (Reconnected)' : ''));

                var newBranches = self.allowedBranches;
                for (let i in newBranches) {
                    if (newBranches[i] == 18) {
                        newBranches.push(14);
                    }
                }
                var newBusiness = self.businessBranches;
                /*for(let i in newBusiness)   {
                    if (newBusiness[i].FILIAL == 'GOIANIA BUENO') {
                        newBusiness[i].FILIAL = 'GOIANIA';
                    }
                }*/
                self.ws.emit('data', {
                    cmd: 'init',
                    payload: {
                        userId: window._sessionData.userId,
                        businessId: self.businessId,
                        businessBranches: newBusiness,
                        allowedBranches: newBranches,
                        filters: {
                            branchId: self.branchFilter,
                            leadType: self.filterLeadType,
                            leadCategoryTypeId: self.filterLeadCategoryTypeId,
                            leadTags: self.filterLeadTags,
                        },
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        },
                        roles: window._sessionData.roles
                    }
                })
                resolve();
            });

            this.ws.on("connect_error", (error) => {
                console.error('[LEADS API] connect_error', 'ERROR');
                console.error(error, 'ERROR');
                self.ws.connect();
                reject();
            });

            this.ws.on("disconnect", (reason) => {
                console.error('[LEADS API] Socket closed/disconnected!! trying to reconnect in 5 seconds.', 'ERROR');
                console.error(reason, 'ERROR');
                self.servHealth = false;
                self.isReconnecting = true; // Marcar como reconectando
                clearInterval(self.totalLeadsIntv);
                self.totalLeadsIntv = false;
                setTimeout(() => {
                    self.ws.connect();
                }, 5000);
            });

            this.ws.on('data', (data) => {
                if (data) {
                    switch (data.cmd) {
                        case 'initiated': {
                            self.leadsCache = data.payload.leads_list;
                            self.leadsTotal = data.payload.total;

                            self.getTotalLeads({
                                createInterval: true
                            })

                            // Se for reconexão e estiver no modo kanban, apenas recarregar dados sem re-renderizar
                            if (self.wasReconnecting && self.viewMode === 'kanban' && self.kanbanRendered) {
                                // Recarregar dados das colunas existentes sem re-renderizar
                                self.loadKanbanColumnData({ loadAll: true }); // Sem tags
                                for (let i in window._sessionData.tags) {
                                    let tag = window._sessionData.tags[i];
                                    if (tag.VISIVEL == 1) {
                                        self.loadKanbanColumnData({ tag: tag.TAG });
                                    }
                                }
                                resolve();
                                return;
                            } else {
                                if (self.viewMode == 'table') {
                                    self.renderLeadsTable();
                                } else {
                                    self.renderKanbanView();
                                }
                            }
                            break;
                        }
                        case 'filtered': {
                            self.leadsCache = data.payload.leads_list;
                            self.leadsTotal = data.payload.total;
                            // Se estiver no modo kanban e já foi renderizado, não re-renderizar
                            if (self.viewMode === 'kanban' && self.kanbanRendered) {
                                // Apenas atualizar cache, não renderizar novamente
                                $(".js-leads-table").unblock();
                            } else {
                                if (self.viewMode == 'table') {
                                    self.renderLeadsTable();
                                } else {
                                    self.renderKanbanView();
                                }
                            }
                            break;
                        }
                        case 'updatedLead': {
                            self.unblockAllButtons();

                            let leadUpdated = false,
                                leadData = false;

                            let oldTags = null; // Armazenar tags antigas para comparar no kanban

                            for (let i in self.leadsCache) {
                                let lead = self.leadsCache[i];
                                if (lead.ID == data.payload.id) {
                                    // Salvar tags antigas antes de atualizar
                                    if (self.viewMode === 'kanban') {
                                        // Sempre usar TAGS pois mountLeadCard usa lead.TAGS
                                        oldTags = lead.TAGS || null;
                                    }

                                    self.leadsCache[i].LEAD_DONO_ID = data.payload.ownerId;
                                    //if (self.leadsCache[i].ALLOWED_LEAD_ROLES == 'SELLER') {
                                    // Ensure tags are string (server might return array)
                                    let newTags = data.payload.tags;
                                    if (Array.isArray(newTags)) {
                                        newTags = newTags.join(',');
                                    }
                                    self.leadsCache[i].TAGS = newTags;
                                    self.leadsCache[i].ULTIMO_CONTATO_DATA = data.payload.lastContactTs;
                                    self.leadsCache[i].CONTATOS_REALIZADOS = data.payload.contactsCount;
                                    //}
                                    /*if (self.leadsCache[i].ALLOWED_LEAD_ROLES == 'SELLER,MANAGER,COMMERCIAL_ASSISTANT' || self.leadsCache[i].ALLOWED_LEAD_ROLES == 'MANAGER,COMMERCIAL_ASSISTANT') {
                                        self.leadsCache[i].TAGS_SECONDARY = data.payload.tags;
                                        self.leadsCache[i].CLINICA_ULTIMO_CONTATO_DATA = data.payload.lastContactTs;
                                        self.leadsCache[i].CLINICA_CONTATOS_REALIZADOS = data.payload.contactsCount;
                                    }*/
                                    leadData = self.leadsCache[i];
                                    leadUpdated = true;
                                    break;
                                }
                            }

                            if (leadUpdated && leadData) {
                                // Atualizar na tabela
                                $('tr').each(function () {
                                    let tableLeadId = $(this).data('lead-id');
                                    if (tableLeadId == data.payload.id) {
                                        if (leadData.ATIVO == 1) {
                                            let rowHtml = self.mountLeadRow(leadData, {
                                                no_tr: true,
                                                locked: /*(window._sessionData.isHunter) && leadData.LEAD_DONO_ID != null && leadData.LEAD_DONO_ID != window._sessionData.userId ? true : */false
                                            });
                                            $(this).html(rowHtml);
                                            //if ((window._sessionData.isHunter) && leadData.LEAD_DONO_ID != null && leadData.LEAD_DONO_ID != window._sessionData.userId) {
                                            //$(this).addClass('locked');
                                            //}
                                        }
                                    }
                                });

                                // Atualizar no kanban
                                if (self.viewMode === 'kanban') {
                                    self.updateLeadInKanban(leadData, oldTags);
                                }

                                if (self.selectedLeadId == data.payload.id) {
                                    window.toast({ error: false, text: "Número de telefone copiado com sucesso." });
                                    self.selectedLeadId = false;

                                    let telefone = leadData.TELEFONE.replace('+55', '');
                                    /*if (telefone[0] == 5 && telefone[1] == 5) {
                                        telefone = '+'+telefone
                                    } else if (telefone[0] != 5 && telefone[1] != 5) {
                                        telefone = '+55'+telefone
                                    }*/

                                    /*if (leadData.CONTATOS_REALIZADOS == 1) {
                                        self.copyToClipboard(`https://web.whatsapp.com/send?phone=${telefone}&text=Olá! tudo bem? Sou especialista das Clínicas Ajustar e vi que tem interesse nos nossos tratamentos. Como posso te ajudar?`);
                                    } else {
                                        self.copyToClipboard(`https://web.whatsapp.com/send?phone=${telefone}&text=Olá! tudo bem? Sou especialista das Clínicas Ajustar.`);
                                    }*/
                                    self.copyToClipboard(`${telefone}`);
                                }
                            }
                            break;
                        }
                        case 'addNewLead': {
                            // this only haapens in kanban view users
                            let lead = data.payload.lead;

                            //console.log('self.branchFilter', self.branchFilter);
                            //console.log('self.branchFilter.toLowerCase()', self.branchFilter.toLowerCase())
                            //console.log('lead.LOCAL_CONVERSAO.toLowerCase()', lead.LOCAL_CONVERSAO.toLowerCase())

                            if (self.branchFilter != '' && self.branchFilter.toLowerCase() != lead.LOCAL_CONVERSAO.toLowerCase())
                                return;

                            self.unblockAllButtons();

                            let tag = lead.TAGS || '';
                            let tagKey = tag === '' ? '__no_tag__' : tag;
                            let columnSelector = tag === '' ? '[data-tag-column=""]' : `[data-tag-column="${tagKey}"]`;
                            let columnHtml = self.mountLeadCard(lead, {
                                locked: false
                            });
                            if ($(columnSelector).length > 0) {
                                $(columnSelector).prepend(columnHtml);
                            } else {
                                console.log('[addNewLead] Coluna não encontrada:', tag);
                            }

                            window.toast({ error: false, text: "Novo lead adicionado na coluna " + tag });

                            //pla ysound https://thequiro.clinicasajustar.com.br/assets/sound/novo_lead.mp3
                            if (typeof Audio !== 'undefined') {
                                let audio = new Audio('https://thequiro.clinicasajustar.com.br/assets/sound/novo_lead.mp3');
                                audio.play();
                            }

                            break;
                        }
                        case 'removeLead': {
                            //console.log('removeLead', data.payload);
                            self.unblockAllButtons();

                            let leadFound = false,
                                leadData = false;

                            for (let i in self.leadsCache) {
                                let lead = self.leadsCache[i];
                                if (lead.ID == data.payload.id) {
                                    self.leadsCache[i] = null;
                                    leadData = self.leadsCache[i];
                                    leadFound = true;
                                    break;
                                }
                            }

                            if (leadFound) {
                                self.leadsCache = self.leadsCache.filter((obj) => obj !== null);
                                $('tr').each(function () {
                                    let tableLeadId = $(this).data('lead-id');
                                    if (tableLeadId == data.payload.id) {
                                        $(this).remove();
                                    }
                                });
                            }
                            break;
                        }
                        case 'kanbanFiltered': {
                            // Recebe dados de uma coluna específica do kanban
                            let tag = data.payload.tag || '';
                            let tagKey = tag === '' ? '__no_tag__' : tag;
                            let leads = data.payload.leads_list || [];
                            let total = data.payload.total || 0;
                            let isLoadMore = data.payload.isLoadMore || false;
                            let columnSelector = tag === '' ? '[data-tag-column=""]' : `[data-tag-column="${tag}"]`;
                            let loadMoreBtnSelector = tag === '' ? '[data-load-more-column=""]' : `[data-load-more-column="${tag}"]`;

                            let columnHtml = '';
                            for (let i = leads.length - 1; i >= 0; i--) {
                                let lead = leads[i];
                                if (lead.ATIVO == 1) {
                                    columnHtml += self.mountLeadCard(lead, {
                                        locked: false
                                    });
                                }
                            }

                            if (isLoadMore) {
                                // Append novos leads aos existentes
                                if (columnHtml !== '') {
                                    $(loadMoreBtnSelector).before(columnHtml);
                                }

                                // Atualizar página atual
                                let currentPage = self.kanbanColumnsPages[tagKey] || 1;
                                self.kanbanColumnsPages[tagKey] = currentPage + 1;

                                // Verificar se há mais páginas
                                let recordsPerPage = parseInt($('.js-filter-leads-per-page').val());
                                let hasMore = (self.kanbanColumnsPages[tagKey] * recordsPerPage) < total;

                                // Reabilitar botão
                                let loadMoreBtn = $(loadMoreBtnSelector).find('.js-kanban-load-more');
                                if (!hasMore) {
                                    // Não há mais leads, remover botão
                                    $(loadMoreBtnSelector).remove();
                                } else {
                                    // Reabilitar botão
                                    loadMoreBtn.prop('disabled', false).html('<i class="fas fa-plus"></i> Carregar mais');
                                }
                            } else {
                                // Primeira carga ou recarga completa
                                if (columnHtml === '') {
                                    columnHtml = '<div class="text-muted text-center p-3"><small>Nenhum lead nesta coluna</small></div>';
                                }

                                $(columnSelector).html(columnHtml);

                                // Adicionar botão "Carregar mais" se houver mais páginas e leads
                                let recordsPerPage = parseInt($('.js-filter-leads-per-page').val());
                                let hasMore = total > 0 && recordsPerPage < total;

                                if (hasMore) {
                                    let loadMoreBtn = `<div class="text-center mt-2" data-load-more-column="${tag}">
                                        <button class="btn btn-sm btn-outline-primary js-kanban-load-more" data-tag="${tag}" style="width: 100%;">
                                            <i class="fas fa-plus"></i> Carregar mais
                                        </button>
                                    </div>`;
                                    $(columnSelector).append(loadMoreBtn);
                                }

                                // Inicializar página da coluna
                                self.kanbanColumnsPages[tagKey] = 1;
                            }

                            $(".js-leads-kanban-container").unblock();
                            break;
                        }
                        case 'totalLeads': {
                            let clinicTodayLeadCount = data.payload.today;
                            let clinicCurrentMonthLeadCount = data.payload.month;
                            let sdrTodayLeadCount = data.payload.sdrDay;
                            let sdrCurrentMonthLeadCount = data.payload.sdrMonth;

                            if (self.crmMode == 'geral') {
                                $('.js-crm-leads-today').html(clinicTodayLeadCount + sdrTodayLeadCount);
                                $('.js-crm-leads-month').html(clinicCurrentMonthLeadCount + sdrCurrentMonthLeadCount);
                            } if (self.crmMode == 'clinica') {
                                $('.js-crm-leads-today').html(clinicTodayLeadCount);
                                $('.js-crm-leads-month').html(clinicCurrentMonthLeadCount);
                            } if (self.crmMode == 'sdr') {
                                $('.js-crm-leads-today').html(sdrTodayLeadCount);
                                $('.js-crm-leads-month').html(sdrCurrentMonthLeadCount);
                            }

                            self.fetchAgendaInsights();
                            break;
                        }
                        case 'totalLeadsFiltered': {
                            let clinicCurrentMonthLeadCount = data.payload.month;
                            let sdrCurrentMonthLeadCount = data.payload.sdrMonth;

                            $('#crm-date-data-leads-geral').html(clinicCurrentMonthLeadCount + sdrCurrentMonthLeadCount);
                            $('#crm-date-data-leads-clinica').html(clinicCurrentMonthLeadCount);
                            $('#crm-date-data-leads-sdr').html(sdrCurrentMonthLeadCount);
                            break;
                        }
                        case 'updateAllowedBranchesResponse': {
                            if (self.viewMode === 'table') {
                                if (self.ws) {
                                    self.ws.emit('data', {
                                        cmd: 'filterByLeadTags',
                                        payload: {
                                            userId: window._sessionData.userId,
                                            name: self.filterLeadTags,
                                            pagination: {
                                                page: self.tableHandler.getCurrentPage(),
                                                recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                                                filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                                            }
                                        }
                                    })
                                }
                            } else {
                                self.renderKanbanView();
                                self.fetchAgendaInsights();
                                self.getTotalLeads({
                                    createInterval: false
                                })
                            }

                            break;
                        }

                        case 'error': {
                            self.unblockAllButtons();
                            // Reabilitar botões "Carregar mais" em caso de erro
                            $('.js-kanban-load-more').each(function () {
                                $(this).prop('disabled', false).html('<i class="fas fa-plus"></i> Carregar mais');
                            });
                            window.toast({
                                error: data.payload.error,
                                text: data.payload.message
                            })
                            break;
                        }
                    }
                }
            });

            this.ws.on('error', (error) => {
                self.servHealth = false;
                console.log('[LEADS API] error', 'ERROR');
                console.log(error, 'ERROR');
            });
        });
    }

    getTotalLeads(opts = { createInterval: true }) {
        let self = this;
        if (opts.createInterval) {
            if (self.totalLeadsIntv != false) {
                clearInterval(self.totalLeadsIntv);
                self.totalLeadsIntv = false;
            } else {
                self.ws.emit('data', {
                    cmd: 'getTotalLeads',
                    payload: {
                        userId: window._sessionData.userId,
                    }
                });
            }

            self.totalLeadsIntv = setInterval(() => {
                if (self.ws) {
                    $('.js-crm-leads-today').html('...');
                    $('.js-crm-leads-month').html('...');
                    self.ws.emit('data', {
                        cmd: 'getTotalLeads',
                        payload: {
                            userId: window._sessionData.userId,
                        }
                    });
                }
            }, 60000);
        } else {
            if (self.ws) {
                $('.js-crm-leads-today').html('...');
                $('.js-crm-leads-month').html('...');
                self.ws.emit('data', {
                    cmd: 'getTotalLeads',
                    payload: {
                        userId: window._sessionData.userId,
                    }
                });
            }
        }
    }

    fetchAgendaInsights() {
        let self = this;

        $('.js-crm-scheduled').html('...');
        $('.js-crm-scheduled-today').html('...');
        $('.js-crm-efficiency').html('...');
        $('.js-crm-leads-today-efficiency').html('...');
        $('.js-crm-leads-month-efficiency').html('...');
        $('.js-crm-leads-today-cac').html('...');
        $('.js-crm-leads-today-investment').html('...');

        fetch(window._baseDir + 'api/v1/business/insights?report=HOMEPAGE_HUNTER_GLASS_DOOR&period=DEFAULT&marketingPage=1' + (this.branchId != -1 ? '&branchId=' + this.branchId : '&franchise=' + this.onlyFranchise), {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("HTTP error " + response.status);
                }
                return response.json();
            })
            .then((res) => {
                //console.log('res', res);
                let clinicTotalSchedules = 0;
                let aiAgentTotalSchedules = 0;
                let hunterTotalSchedules = 0;
                let clinicTotalSchedulesD2 = 0;
                let aiAgentTotalSchedulesD2 = 0;
                let hunterTotalSchedulesD2 = 0;
                let clinicTotalSchedulesToday = 0;
                let aiAgentTotalSchedulesToday = 0;
                let hunterTotalSchedulesToday = 0;

                let resultsData = res.data.results;

                for (let i in resultsData.d_mais_um) {
                    let glassDoorRowInfo = res.data.results.d_mais_um[i];
                    //console.log('dmais um', glassDoorRowInfo);

                    let countClinicSchedulesD1 = 0;
                    let countHunterSchedulesD1 = 0;
                    let countAiAgentSchedulesD1 = 0;

                    for (let x in Object.keys(glassDoorRowInfo)) {
                        let objKeyName = Object.keys(glassDoorRowInfo)[x];
                        let objKeyValue = parseInt(Object.values(glassDoorRowInfo)[x]);

                        //console.log('dmais um1', objKeyName, objKeyValue);

                        if (objKeyName.indexOf('CLINICA') !== -1) {
                            countClinicSchedulesD1 = countClinicSchedulesD1 + objKeyValue;
                        } else if (objKeyName.indexOf('ROBO') !== -1) {
                            countHunterSchedulesD1 = countHunterSchedulesD1 + objKeyValue;
                        } else if (objKeyName.indexOf('HUNTER') !== -1) {
                            countAiAgentSchedulesD1 = countAiAgentSchedulesD1 + objKeyValue;
                        }
                    }

                    /*$('.js-clinic-campaign-schedules-next-day').each(function () {
                        let type = $(this).data('type'),
                            filialId = $(this).data('filial-id');

                        //console.log('filialId', filialId);
                        //console.log('branches[glassDoorRowInfo.FILIAL_ID]', branches[glassDoorRowInfo.FILIAL_ID]);
                        if (filialId == branches[glassDoorRowInfo.FILIAL_ID]) {
                            if (type == 'clinica') {
                                $(this).html(countClinicSchedulesD1);
                            } else if (type == 'hunter') {
                                $(this).html(countHunterSchedulesD1);
                            } else if (type == 'mabel') {
                                $(this).html(countAiAgentSchedulesD1);
                            }
                        }
                    });*/

                    clinicTotalSchedules += countClinicSchedulesD1;
                    hunterTotalSchedules += countHunterSchedulesD1;
                    aiAgentTotalSchedules += countAiAgentSchedulesD1;
                }

                for (let i in resultsData.d_mais_dois) {
                    let glassDoorRowInfo = res.data.results.d_mais_dois[i];

                    let countClinicSchedulesD2 = 0;
                    let countHunterSchedulesD2 = 0;
                    let countAiAgentSchedulesD2 = 0;

                    for (let x in Object.keys(glassDoorRowInfo)) {
                        let objKeyName = Object.keys(glassDoorRowInfo)[x];
                        let objKeyValue = parseInt(Object.values(glassDoorRowInfo)[x]);
                        if (objKeyName.indexOf('CLINICA') !== -1) {
                            countClinicSchedulesD2 = countClinicSchedulesD2 + objKeyValue;
                        } else if (objKeyName.indexOf('ROBO') !== -1) {
                            countHunterSchedulesD2 = countHunterSchedulesD2 + objKeyValue;
                        } else if (objKeyName.indexOf('HUNTER') !== -1) {
                            countAiAgentSchedulesD2 = countAiAgentSchedulesD2 + objKeyValue;
                        }
                    }

                    /*$('.js-clinic-campaign-schedules-d2').each(function () {
                        let type = $(this).data('type'),
                            filialId = $(this).data('filial-id');

                        if (filialId == branches[glassDoorRowInfo.FILIAL_ID]) {
                            if (type == 'clinica') {
                                $(this).html(countClinicSchedulesD2);
                            } else if (type == 'hunter') {
                                $(this).html(countHunterSchedulesD2);
                            } else if (type == 'mabel') {
                                $(this).html(countAiAgentSchedulesD2);
                            }
                        }
                    });*/

                    clinicTotalSchedulesD2 += countClinicSchedulesD2;
                    hunterTotalSchedulesD2 += countHunterSchedulesD2;
                    aiAgentTotalSchedulesD2 += countAiAgentSchedulesD2;
                }

                for (let i in resultsData.d_hoje) {
                    let glassDoorRowInfo = res.data.results.d_hoje[i];

                    let countClinicSchedulesToday = 0;
                    let countHunterSchedulesToday = 0;
                    let countAiAgentSchedulesToday = 0;

                    for (let x in Object.keys(glassDoorRowInfo)) {
                        let objKeyName = Object.keys(glassDoorRowInfo)[x];
                        let objKeyValue = parseInt(Object.values(glassDoorRowInfo)[x]);
                        if (objKeyName.indexOf('CLINICA') !== -1) {
                            countClinicSchedulesToday = countClinicSchedulesToday + objKeyValue;
                        } else if (objKeyName.indexOf('ROBO') !== -1) {
                            countHunterSchedulesToday = countHunterSchedulesToday + objKeyValue;
                        } else if (objKeyName.indexOf('HUNTER') !== -1) {
                            countAiAgentSchedulesToday = countAiAgentSchedulesToday + objKeyValue;
                        }
                    }

                    /*$('.js-clinic-campaign-schedules-today').each(function () {
                        let type = $(this).data('type'),
                            filialId = $(this).data('filial-id');

                        if (filialId == branches[glassDoorRowInfo.FILIAL_ID]) {
                            if (type == 'clinica') {
                                $(this).html(countClinicSchedulesToday);
                            } else if (type == 'hunter') {
                                $(this).html(countHunterSchedulesToday);
                            } else if (type == 'mabel') {
                                $(this).html(countAiAgentSchedulesToday);
                            }
                        }
                    });*/

                    clinicTotalSchedulesToday += countClinicSchedulesToday;
                    hunterTotalSchedulesToday += countHunterSchedulesToday;
                    aiAgentTotalSchedulesToday += countAiAgentSchedulesToday;
                }

                let totalLeadsToday = $('.js-crm-leads-today').html();

                //console.log('clinicTotalSchedulesToday', clinicTotalSchedules, clinicTotalSchedulesToday);
                //console.log('hunterTotalSchedulesToday', hunterTotalSchedules, hunterTotalSchedulesToday);
                //console.log('totalLeadsToday', totalLeadsToday);

                if (self.crmMode == 'geral') {
                    $('.js-crm-scheduled-today').html(clinicTotalSchedulesToday + hunterTotalSchedulesToday);
                    $('.js-crm-scheduled').html(clinicTotalSchedules + hunterTotalSchedules);
                    $('.js-crm-leads-today-efficiency').html(clinicTotalSchedules != 0 ? (((clinicTotalSchedules + clinicTotalSchedulesToday + hunterTotalSchedules + hunterTotalSchedulesToday) / totalLeadsToday) * 100).toFixed(2) + '%' : 0);
                } else if (self.crmMode == 'clinica') {
                    $('.js-crm-scheduled-today').html(clinicTotalSchedulesToday);
                    $('.js-crm-scheduled').html(clinicTotalSchedules);
                    $('.js-crm-leads-today-efficiency').html(clinicTotalSchedules != 0 ? (((clinicTotalSchedules + clinicTotalSchedulesToday) / totalLeadsToday) * 100).toFixed(2) + '%' : 0);
                } else if (self.crmMode == 'sdr') {
                    $('.js-crm-scheduled-today').html(hunterTotalSchedulesToday);
                    $('.js-crm-scheduled').html(hunterTotalSchedules);
                    $('.js-crm-leads-today-efficiency').html(hunterTotalSchedules != 0 ? (((hunterTotalSchedules + hunterTotalSchedulesToday) / totalLeadsToday) * 100).toFixed(2) + '%' : 0);
                }
                //$('.js-crm-leads-d-plus-2').html(clinicTotalSchedulesD2);

                self.fetchNewPatientsMonthlyTotal();
                self.fetchAdCampaignAcquisitionCost();
            }).catch((err) => {
                console.error('errr', err);
            });
    }

    fetchNewPatientsMonthlyTotal() {
        let self = this;
        fetch(window._baseDir + 'api/v1/marketing/insights?report=MARKETING_REPORT_PATIENTS_BY_ORIGINS_AND_BRANCHES&period=DEFAULT&originId=Lead&type=PN-TOTAL-SCHEDULES-ATTENDED' + (this.branchId != -1 ? '&branchId=' + this.branchId : '&franchise=' + this.onlyFranchise), {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("HTTP error " + response.status);
                }
                return response.json();
            })
            .then((res) => {
                let totalNewPatientsFromLeadOrigin = 0;
                let sdrNewPatientsFromLeadOrigin = 0;
                for (let i = 0; i < res.results.current_origins.length; ++i) {
                    const data = res.results.current_origins[i];
                    totalNewPatientsFromLeadOrigin += parseInt(data.TOTAL_SCHEDULES);
                }

                for (let i = 0; i < res.results.current_origins_robos.length; ++i) {
                    const data = res.results.current_origins_robos[i];
                    sdrNewPatientsFromLeadOrigin += parseInt(data.TOTAL_SCHEDULES);
                }
                //console.log('totalNewPatientsFromLeadOrigin', totalNewPatientsFromLeadOrigin);
                //console.log('sdrNewPatientsFromLeadOrigin', sdrNewPatientsFromLeadOrigin);
                //console.log('asssself.crmMode', self.crmMode);

                let totalLeadsMonth = parseInt($('.js-crm-leads-month').html());

                if (self.crmMode == 'geral') {
                    //console.log('geral', totalNewPatientsFromLeadOrigin, sdrNewPatientsFromLeadOrigin, totalNewPatientsFromLeadOrigin);
                    //console.log('geral', totalNewPatientsFromLeadOrigin + sdrNewPatientsFromLeadOrigin, typeof totalLeadsMonth);
                    $('.js-crm-leads-month-efficiency').html(totalNewPatientsFromLeadOrigin != 0 ? (((totalNewPatientsFromLeadOrigin + sdrNewPatientsFromLeadOrigin) / totalLeadsMonth) * 100).toFixed(2) + '%' : 0);
                } else if (self.crmMode == 'clinica') {
                    $('.js-crm-leads-month-efficiency').html(totalNewPatientsFromLeadOrigin != 0 ? ((totalNewPatientsFromLeadOrigin / totalLeadsMonth) * 100).toFixed(2) + '%' : 0);
                } else if (self.crmMode == 'sdr') {
                    $('.js-crm-leads-month-efficiency').html(sdrNewPatientsFromLeadOrigin != 0 ? ((sdrNewPatientsFromLeadOrigin / totalLeadsMonth) * 100).toFixed(2) + '%' : 0);
                }
            }).catch((err) => {
                console.error('errr', err);
            });
    }

    fetchAdCampaignAcquisitionCost() {
        let self = this;

        if (self.deps.userHasRole('ADMIN')) {

            let queryParams = '';
            if (self.branchId != -1) {
                queryParams += '?branchId=' + self.branchId;
            }
            if (self.onlyFranchise) {
                queryParams += (queryParams == '' ? '?' : '&') + 'franchise=true';
            }

            fetch(window._baseDir + 'api/v1/marketing/meta-campaign-results' + queryParams, {
                method: 'GET',
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error("HTTP error " + response.status);
                    }
                    return response.json();
                })
                .then((res) => {
                    //console.log('res', res);

                    let totalCost = 0;
                    let sdrTotalCost = 0;

                    for (let i = 0; i < Object.keys(res.data).length; ++i) {
                        const data = Object.values(res.data)[i];
                        if (self.branchId != -1 && self.branchId != Object.keys(res.data)[i]) {
                            continue;
                        }
                        totalCost += parseInt(data.spend);
                    }

                    for (let i = 0; i < Object.keys(res.data_sdr).length; ++i) {
                        const data = Object.values(res.data_sdr)[i];
                        if (self.branchId != -1 && self.branchId != Object.keys(res.data_sdr)[i]) {
                            continue;
                        }
                        sdrTotalCost += parseInt(data.spend);
                    }

                    let totalLeads = $('.js-crm-leads-today').html();

                    if (self.crmMode == 'geral') {
                        let cac = totalLeads != 0 ? ((totalCost + sdrTotalCost) / totalLeads) : 0;
                        $('.js-crm-leads-today-cac').html(cac.toFixed(2));
                        $('.js-crm-leads-today-investment').html(totalCost + sdrTotalCost);
                    } else if (self.crmMode == 'clinica') {
                        let cac = totalLeads != 0 ? (totalCost / totalLeads) : 0;
                        $('.js-crm-leads-today-cac').html(cac.toFixed(2));
                        $('.js-crm-leads-today-investment').html(totalCost);
                    } else if (self.crmMode == 'sdr') {
                        let cac = totalLeads != 0 ? (sdrTotalCost / totalLeads) : 0;
                        $('.js-crm-leads-today-cac').html(cac.toFixed(2));
                        $('.js-crm-leads-today-investment').html(sdrTotalCost);
                    }

                    //console.log('totalCost', totalCost);
                    //console.log('cac', cac);
                }).catch((err) => {
                    console.error('errr', err);
                });
        }
    }

    bindStrategyPaginationPageChange() {
        let self = this;
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            $(".js-leads-table").block(window._loader.loading);
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'changePage',
                    payload: {
                        userId: window._sessionData.userId,
                        businessId: self.businessId,
                        businessBranches: self.businessBranches,
                        allowedBranches: self.allowedBranches,
                        branchId: self.branchFilter,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
        });
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            $(".js-leads-table").block(window._loader.loading);
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'changePage',
                    payload: {
                        userId: window._sessionData.userId,
                        businessId: self.businessId,
                        businessBranches: self.businessBranches,
                        allowedBranches: self.allowedBranches,
                        branchId: self.branchFilter,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
        });
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            $(".js-leads-table").block(window._loader.loading);
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'changePage',
                    payload: {
                        userId: window._sessionData.userId,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
        });
        $('.js-filter-leads-per-page').change(function () {
            $(".js-leads-table").block(window._loader.loading);
            let val = parseInt($(this).val());
            self.tableHandler.setRowsPerPage(val);
            self.tableHandler.setCurrentPage(1);
            //self.bindStrategyReadForm();
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'changePage',
                    payload: {
                        userId: window._sessionData.userId,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
        });
    }

    renderLeadsTable(opts = {
        makeKanbanColumns: true
    }) {
        if (this.viewMode === 'kanban') {
            this.renderKanbanView(opts);
            return;
        }

        let tableHtml = '';

        this.leadsCache.sort((a, b) => {
            // Sort by CADASTRO_DATA in descending order
            if (a.CADASTRO_DATA > b.CADASTRO_DATA) return -1;
            if (a.CADASTRO_DATA < b.CADASTRO_DATA) return 1;

            // If CADASTRO_DATA is the same, sort by ULTIMO_CONTATO_DATA (if not null)
            if (a.ULTIMO_CONTATO_DATA !== null && b.ULTIMO_CONTATO_DATA !== null) {
                if (a.ULTIMO_CONTATO_DATA > b.ULTIMO_CONTATO_DATA) return -1;
                if (a.ULTIMO_CONTATO_DATA < b.ULTIMO_CONTATO_DATA) return 1;
            } else if (a.ULTIMO_CONTATO_DATA === null && b.ULTIMO_CONTATO_DATA !== null) {
                return 1; // Move objects with null ULTIMO_CONTATO_DATA to the end
            } else if (a.ULTIMO_CONTATO_DATA !== null && b.ULTIMO_CONTATO_DATA === null) {
                return -1; // Move objects with null ULTIMO_CONTATO_DATA to the end
            }

            return 0; // Objects are equal
        });


        /*for(let i in this.leadsCache) {
            let lead = this.leadsCache[i];
            tableHtml += this.mountLeadRow(lead, {
                no_tr:false,
                locked: lead.LEAD_DONO_ID != null && lead.LEAD_DONO_ID != window._sessionData.userId ? true : false
            });
        }*/
        //$('.js-leads-list').html(tableHtml);
        this.tableHandler.renderPage(this.tableHandler.getCurrentPage(), false, this.leadsCache, false, this.leadsTotal);
        $(".js-leads-table").unblock();
    }

    renderKanbanView(opts = {
        makeKanbanColumns: true
    }) {
        let self = this;

        // Se já está renderizado e não precisa recriar colunas, apenas recarregar dados
        if (this.kanbanRendered && !opts.makeKanbanColumns) {
            // Resetar páginas ao recarregar
            this.kanbanColumnsPages = {};
            this.loadKanbanColumnData({ loadAll: true }); // Sem tags
            for (let i in window._sessionData.tags) {
                let tag = window._sessionData.tags[i];
                if (tag.VISIVEL == 1) {
                    this.loadKanbanColumnData({ tag: tag.TAG });
                }
            }
            return;
        }

        // Resetar páginas ao renderizar
        this.kanbanColumnsPages = {};
        $(".js-leads-kanban-container").html('');
        $(".js-leads-kanban-container").block(window._loader.loading);

        if (!window._sessionData.tags || window._sessionData.tags.length === 0) {
            $(".js-leads-kanban-container").html('<div class="alert alert-info">Carregando tags...</div>');
            $(".js-leads-kanban-container").unblock();
            return;
        }

        // Criar coluna "Sem Tags" primeiro
        let kanbanHtml = '<div class="kanban-column" data-tag="" style="min-width: 300px; max-width: 300px; background: #f8f9fa; border-radius: 8px; padding: 15px; margin-right: 15px;">';
        kanbanHtml += '<h5 class="mb-3" style="font-weight: 600; border-bottom: 2px solid #dee2e6; padding-bottom: 10px;">novos leads</h5>';
        kanbanHtml += '<div class="kanban-column-leads" data-tag-column=""></div>';
        kanbanHtml += '</div>';

        // Criar colunas para cada tag
        for (let i in window._sessionData.tags) {
            let tag = window._sessionData.tags[i];
            if (tag.VISIVEL == 1) {
                kanbanHtml += '<div class="kanban-column" data-tag="' + tag.TAG + '" style="min-width: 300px; max-width: 300px; background: #f8f9fa; border-radius: 8px; padding: 15px; margin-right: 15px;">';
                kanbanHtml += '<h5 class="mb-3" style="font-weight: 600; border-bottom: 2px solid #dee2e6; padding-bottom: 10px;">' + tag.TAG + '</h5>';
                kanbanHtml += '<div class="kanban-column-leads" data-tag-column="' + tag.TAG + '"></div>';
                kanbanHtml += '</div>';
            }
        }

        $(".js-leads-kanban-container").html(kanbanHtml);
        this.kanbanRendered = true; // Marcar como renderizado

        if (opts.makeKanbanColumns) {
            // Carregar leads para cada coluna
            this.loadKanbanColumnData({ loadAll: true }); // Sem tags
            for (let i in window._sessionData.tags) {
                let tag = window._sessionData.tags[i];
                if (tag.VISIVEL == 1) {
                    this.loadKanbanColumnData({ tag: tag.TAG });
                }
            }
        }
    }

    loadKanbanColumnData(opts = { tag: null, page: 1, loadAll: false, isLoadMore: false }) {
        let self = this;
        if (!this.ws) return;

        let tagKey = opts.tag === null || opts.tag === '' ? '__no_tag__' : opts.tag;

        // Se for load more, usar a próxima página
        if (opts.isLoadMore) {
            let currentPage = self.kanbanColumnsPages[tagKey] || 1;
            opts.page = currentPage + 1;
        } else {
            // Resetar página para 1 se não for load more
            self.kanbanColumnsPages[tagKey] = 1;
            opts.page = 1;
        }

        if (opts.loadAll) {
            this.isLoadingAllKanbanColumns = true;
            /*
            TODO: Implement wait to load all columns in one emit command
            for (let i in window._sessionData.tags) {
                if (window._sessionData.tags[i].VISIVEL == 1) {
                    opts.tag.push(window._sessionData.tags[i].TAG);
                }
            }*/
        }

        this.ws.emit('data', {
            cmd: 'filterByLeadTags',
            payload: {
                userId: window._sessionData.userId,
                name: opts.tag ? [opts.tag] : null,
                isKanbanView: true,
                isLoadMore: opts.isLoadMore || false,
                tag: opts.tag || '',
                pagination: {
                    page: opts.page || 1,
                    recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                    filter: JSON.stringify(opts.filters || self.tableHandler.getCurrentFilters())
                }
            }
        });
    }

    mountLeadCard(lead, opts = {
        locked: false
    }) {
        if (opts.locked && !window._sessionData.isHunter || opts.locked && window._sessionData.isHunter && window._sessionData.isManager
            || opts.locked && window._sessionData.isManager) {
            opts.locked = false;
        }
        if (opts.locked) {
            lead = {
                NOME: 'Nome omitido',
                LOCAL_CONVERSAO: 'Omitido',
                MIDIA: 'Omitido',
                ORIGEM: 'Omitido',
                CONTATOS_REALIZADOS: 0,
                TELEFONE: null,
                CELULAR: null
            }
        }

        let leadTags = /*lead.ALLOWED_LEAD_ROLES == 'SELLER' ? lead.TAGS : lead.TAGS_SECONDARY*/ lead.TAGS,
            leadTagsHTML = '';

        if (leadTags) {
            leadTags = leadTags.split(",");
            for (let i in leadTags) {
                leadTagsHTML += `&nbsp;<span class="badge bg-warning" style="font-size: 8px; padding: 2px 4px;">${leadTags[i]}</span>`
            }
        }

        return `
            <div class="card mb-2 kanban-card" data-lead-id="${lead.ID}" style="cursor: pointer; box-shadow: 0 1px 3px rgba(0,0,0,0.1); font-size: 11px;">
                <div class="card-body" style="padding: 8px;">
                    <div class="d-flex justify-content-between align-items-start mb-1">
                        <h6 class="card-title mb-0" style="font-size: 12px; font-weight: 600; line-height: 1.2;">${lead.NOME}</h6>
                        ${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `
                        <small class="text-muted" style="font-size: 9px;">#${lead.ID}</small>
                        ` : ''}
                    </div>
                    <div class="mb-1" style="line-height: 1.3;">
                        <span class="badge bg-primary" style="font-size: 8px; padding: 2px 4px;">${lead.LOCAL_CONVERSAO}</span> 
                        <span class="badge bg-secondary" style="font-size: 8px; padding: 2px 4px;">${lead.MIDIA}</span>
                        ${leadTagsHTML}
                    </div>
                    <div class="d-flex gap-1 mb-1">
                        <button type="button" class="btn btn-sm btn-whatsapp js-lead-contact flex-fill" data-lead-id="${lead.ID}" data-owner-id="${lead.LEAD_DONO_ID}" style="font-size: 9px; padding: 2px 6px; line-height: 1.2;">
                            <i class="fab fa-whatsapp"></i>
                        </button>
                        <div class="dropdown">
                            <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="font-size: 9px; padding: 2px 6px; line-height: 1.2;">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item js-lead-add-tag" data-lead-id="${lead.ID}" data-info='${JSON.stringify(lead)}' href="#">Adicionar Tag</a></li>
                                ${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `
                                <li><a class="dropdown-item js-lead-transfer" data-lead-id="${lead.ID}" data-info='${JSON.stringify(lead)}' href="#">Transferir Lead</a></li>
                                ` : ''}
                                ${window._sessionData.isManager || window._sessionData.isAdmin ? ` <li><a class="dropdown-item js-lead-inactivate" data-lead-id="${lead.ID}" data-info='${JSON.stringify(lead)}' href="#">Desativar Lead</a></li>` : ''}
                            </ul>
                        </div>
                    </div>
                    ${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `
                    <small class="text-muted" style="font-size: 8px;">${lead.CONTATOS_REALIZADOS} contatos</small>
                    ` : ''}
                </div>
            </div>
        `;
    }

    mountLeadRow(lead, opts = {
        no_tr: false,
        locked: false
    }) {
        if (opts.locked && !window._sessionData.isHunter || opts.locked && window._sessionData.isHunter && window._sessionData.isManager
            || opts.locked && window._sessionData.isManager) {
            opts.locked = false;
        }
        if (opts.locked) {
            lead = {
                NOME: 'Nome omitido',
                LOCAL_CONVERSAO: 'Omitido',
                MIDIA: 'Omitido',
                ORIGEM: 'Omitido',
                CONTATOS_REALIZADOS: 0,
                TELEFONE: null,
                CELULAR: null
            }
        }

        let leadTags = lead.ALLOWED_LEAD_ROLES == 'SELLER' ? lead.TAGS : lead.TAGS_SECONDARY,
            leadTagsHTML = '';

        if (leadTags) {
            leadTags = leadTags.split(",");
            for (let i in leadTags) {
                leadTagsHTML += `&nbsp;<span class="badge bg-warning">${leadTags[i]}</span>`
            }
        }

        return `
            ${!opts.no_tr ? `<tr class="${opts.locked ? 'locked' : ''}" data-lead-id="${lead.ID}">` : ''}
                ${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `
                <td data-label="#">${lead.ID}</td>
                ` : ''}
                <td data-label="Nome">
                    ${lead.NOME} ${lead.LEAD_DONO_ID != null ? `${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `<small><br />(Hunter: ${lead.LEAD_DONO_ID})</small>` : ''}` : ''}
                    <br>
                    <div>
                        <span class="badge bg-primary">${lead.LOCAL_CONVERSAO}</span> 
                        <span class="badge bg-secondary">${lead.MIDIA}</span> 
                        <span class="badge bg-info">${lead.ORIGEM}</span>
                        ${this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ?
                `<span class="badge bg-warning">${lead.ALLOWED_LEAD_ROLES == 'SELLER' ? 'Hunter'
                    : (lead.ALLOWED_LEAD_ROLES == 'MANAGER,COMMERCIAL_ASSISTANT' ? 'Clínica'
                        : (lead.ALLOWED_LEAD_ROLES == 'SELLER,MANAGER,COMMERCIAL_ASSISTANT' ? 'Ambos' : ''))}</span>` : ''}
                        ${leadTagsHTML}
                    </div>
                    ${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `
                        <small>Cadastrado em ${moment.unix(lead.CADASTRO_DATA).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}</small>
                    ` : ''}
                </td>
                <td data-label="Conversar">
                    <button type="button" class="btn btn-whatsapp js-lead-contact" data-lead-id="${lead.ID}" data-owner-id="${lead.LEAD_DONO_ID}">
                        <i class="fab fa-whatsapp"></i> ${lead.CONTATOS_REALIZADOS == 0 && this.deps.userHasRole('SELLER') ? 'Copiar cel. p/primeiro contato' : 'Copiar cel. p/Enviar mensagem'}
                    </button>
                    <!--
                    <br>
                    <button type="button" class="btn btn-secondary js-lead-contact-via-email my-2" data-lead-id="${lead.ID}" data-owner-id="${lead.LEAD_DONO_ID}">
                        <i class="fas fa-envelope"></i> ${!lead.EMAILS_ENVIADOS ? 'Enviar primeiro email' : 'E-mail enviado'}
                    </button>
                    -->
                </td>
                ${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `
                <td data-label="Contatos Realizados">
                    ${lead.CONTATOS_REALIZADOS}<br />
                    <small>${lead.ULTIMO_CONTATO_DATA == null ?
                    'Nunca' : moment.unix(lead.ULTIMO_CONTATO_DATA).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}</small>
                </td>
                ` : ''}
                ${this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') || this.deps.userHasRole('MANAGER') || this.deps.userHasRole('COMMERCIAL_ASSISTANT') ? `
                <td data-label="Contatos Realizados (Clínica)">
                    ${lead.CLINICA_CONTATOS_REALIZADOS}<br />
                    <small>${lead.CLINICA_ULTIMO_CONTATO_DATA == null ?
                    'Nunca' : moment.unix(lead.CLINICA_ULTIMO_CONTATO_DATA).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}</small>
                </td>
                ` : ''}
                <td data-label="Ações">
                    <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="leadActionButton" data-bs-toggle="dropdown" aria-expanded="false">
                            Ações
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="leadActionButton">
                            <li><a class="dropdown-item js-lead-add-tag" data-lead-id="${lead.ID}" data-info='${JSON.stringify(lead)}' href="#">Adicionar Tag</a></li>
                            ${this.deps.userHasRole('SELLER') || this.deps.userHasRole('ADMIN') || this.deps.userHasRole('SUPERVISOR') ? `
                            <li><a class="dropdown-item js-lead-transfer" data-lead-id="${lead.ID}" data-info='${JSON.stringify(lead)}' href="#">Transferir Lead</a></li>
                            ` : ''}
                            ${window._sessionData.isManager || window._sessionData.isAdmin ? ` <li><a class="dropdown-item js-lead-inactivate" data-lead-id="${lead.ID}" data-info='${JSON.stringify(lead)}' href="#">Desativar Lead</a></li>` : ''}
                        </ul>
                    </div>
                </td>
            ${!opts.no_tr ? `</tr>` : ''}`
    }

    bindElementsChanges() {
        if (this.elementsBinded)
            return;
        this.elementsBinded = true;
        let self = this;

        this.editLeadId = false;
        this.editLeadInfo = false;

        let tagsArray = [];
        for (let i in window._sessionData.tags) {
            let tag = window._sessionData.tags[i];
            if (tag.VISIVEL == 1) {
                tagsArray.push(tag.TAG);
            }
        }
        //console.log('tagsArray', window._sessionData.tags, tagsArray);

        let el = document.getElementById("mkt-lead-add-tags");
        this.mktAddTagsInstance = new Tagify(el, {
            whitelist: tagsArray,
            placeholder: "Insira uma tag",
            userInput: true,
            enforceWhitelist: true,
            maxTags: 10,
            dropdown: {
                maxItems: 30,           // <- mixumum allowed rendered suggestions
                classname: "tags-look", // <- custom classname for this dropdown, so it could be targeted
                enabled: 0,             // <- show suggestions on focus
                closeOnSelect: false    // <- do not hide the suggestions dropdown once an item has been selected
            },
            templates: {
                dropdownItemNoMatch: function (data) {
                    return `<div class='${this.settings.classNames.dropdownItem}' value="noMatch" tabindex="0" role="option">
                        No suggestion found for: <strong>${data.value}</strong>
                    </div>`
                }
            }
        });

        // Toggle de visualização Tabela/Kanban
        /*$(document).on('click', '.js-leads-view-toggle', function() {
            let view = $(this).data('view');
            self.viewMode = view;
            
            // Atualizar botões ativos
            $('.js-leads-view-toggle').removeClass('active');
            $(this).addClass('active');
            
            // Mostrar/ocultar views
            if (view === 'table') {
                $('.js-leads-table-view').removeClass('d-none');
                $('.js-leads-kanban-view').addClass('d-none');

                if (self.ws) {
                    self.ws.emit('data', {
                        cmd: 'filterByLeadTags',
                        payload: {
                            userId: window._sessionData.userId,
                            name: self.filterLeadTags,
                            pagination: {
                                page: self.tableHandler.getCurrentPage(),
                                recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                                filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                            }
                        }
                    })
                }
            } else {
                $('.js-leads-table-view').addClass('d-none');
                $('.js-leads-kanban-view').removeClass('d-none');
                // Renderizar kanban se ainda não foi renderizado
                if (!self.kanbanRendered || $('.js-leads-kanban-container').children().length === 0) {
                    self.renderKanbanView();
                }
            }
        });*/

        // Handler para botão "Carregar mais" do kanban
        $(document).on('click', '.js-kanban-load-more', function () {
            let tag = $(this).data('tag');
            let tagKey = tag === '' || tag === null ? '__no_tag__' : tag;
            let loadMoreBtn = $(this).closest('[data-load-more-column]');

            // Desabilitar botão enquanto carrega
            $(this).prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Carregando...');

            // Carregar próxima página
            self.loadKanbanColumnData({
                tag: tag,
                page: null,
                isLoadMore: true
            });
        });

        // Detecta operador filtrando lista de filiais permitidas
        $(document).on('change', '.js-leads-list-branches-selector', function () {
            if (self.viewMode === 'table') {
                $(".js-leads-table").block(window._loader.loading);
            } else {
                $(".js-leads-kanban-container").block(window._loader.loading);
            }
            let branchName = $(".js-leads-list-branches-selector option:selected").text();
            self.branchFilter = branchName;
            self.branchId = $(".js-leads-list-branches-selector option:selected").val();
            if (self.branchId == '') {
                self.branchId = -1;
            }
            self.ws.emit('data', {
                cmd: 'filterByBranchName',
                payload: {
                    userId: window._sessionData.userId,
                    name: self.branchFilter,
                    pagination: {
                        page: self.tableHandler.getCurrentPage(),
                        recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                        filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                    }
                }
            })

            if (self.branchFilter == "-- Selecione --") {
                $('.js-leads-database-export-leads').addClass('d-none');
                self.branchId = -1;
            } else {
                $('.js-leads-database-export-leads').removeClass('d-none');
                $('.js-leads-database-export-btn').text('Exportar Leads da Filial: ' + branchName);
                $('.js-leads-database-export-btn').data('branch-id', branchName);
            }

            self.getTotalLeads({
                createInterval: false
            })

            // Se estiver no modo kanban, recarregar
            if (self.viewMode === 'kanban') {
                self.renderKanbanView();
            }
        });

        // Detecta operador filtrando pelo tipo de lead (0: todos / 1: já entrou em contato / 2: nunca entrou em contato)
        $('.js-filter-lead-type').change(function () {
            if (self.viewMode === 'table') {
                $(".js-leads-table").block(window._loader.loading);
            } else {
                $(".js-leads-kanban-container").block(window._loader.loading);
            }
            let val = parseInt($(this).val());
            self.filterLeadType = val;
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'filterByLeadType',
                    payload: {
                        userId: window._sessionData.userId,
                        name: val,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
            // Se estiver no modo kanban, recarregar
            if (self.viewMode === 'kanban') {
                self.renderKanbanView();
            }
        });

        // Detecta operador filtrando pela categoria do lead (0: todos / 1: já entrou em contato / 2: nunca entrou em contato)
        $('.js-filter-lead-category-type').change(function () {
            if (self.viewMode === 'table') {
                $(".js-leads-table").block(window._loader.loading);
            } else {
                $(".js-leads-kanban-container").block(window._loader.loading);
            }
            let val = parseInt($(this).val());
            self.filterLeadCategoryTypeId = val;
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'filterByLeadCategory',
                    payload: {
                        userId: window._sessionData.userId,
                        name: val,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
            // Se estiver no modo kanban, recarregar
            if (self.viewMode === 'kanban') {
                self.renderKanbanView();
            }
        });

        // Detecta operador filtrando por tags de leads
        $('.js-filter-leads-tags').change(function () {
            if (self.viewMode === 'table') {
                $(".js-leads-table").block(window._loader.loading);
            } else {
                $(".js-leads-kanban-container").block(window._loader.loading);
            }
            let val = $(this).val();
            self.filterLeadTags = val;
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'filterByLeadTags',
                    payload: {
                        userId: window._sessionData.userId,
                        name: val,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
            // Se estiver no modo kanban, recarregar
            if (self.viewMode === 'kanban') {
                self.renderKanbanView();
            }
        });

        // Detecta operador clicando para entrar em contato com Lead
        $(document).on('click', '.js-lead-contact', function () {
            let leadId = $(this).data('lead-id'),
                leadOwnerId = $(this).data('owner-id');

            self.blockAllButtons();

            if (self.deps.userHasRole('SELLER') && leadOwnerId !== null && leadOwnerId != window._sessionData.userId) {
                return window.toast({
                    error: true,
                    text: `Este pertence a outro Hunter.`
                })
            }

            self.selectedLeadId = leadId;
            self.ws.emit('data', {
                cmd: 'contactLead',
                payload: {
                    id: leadId,
                    ownerId: window._sessionData.userId,
                    isHunter: window._sessionData.isHunter,
                    userId: window._sessionData.userId,
                }
            })
        });

        // Detecta operador clicando para abrir a janela de adicionar tags ao lead
        $(document).on('click', '.js-lead-add-tag', function (e) {
            e.preventDefault();
            self.editLeadId = $(this).data('lead-id');
            self.editLeadInfo = $(this).data('info');

            //self.mktAddTagsInstance.removeAll();

            let tags = [];
            if (self.editLeadInfo.TAGS /*&& self.deps.userHasRole('SELLER')*/) {
                tags = self.editLeadInfo.TAGS.split(",");
            }

            //console.log('opening add tag modal', self.editLeadId, self.editLeadInfo)

            /*if (self.editLeadInfo.TAGS_SECONDARY && (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('SUPERVISOR') || self.deps.userHasRole('MANAGER') || self.deps.userHasRole('COMMERCIAL_ASSISTANT'))) {
                tags = self.editLeadInfo.TAGS_SECONDARY.split(",");
            }*/

            //console.log('self.mktAddTagsInstance', self.mktAddTagsInstance);
            if (tags) {
                //console.log('tags', tags);
                for (let i in tags) {
                    self.mktAddTagsInstance.addTags(tags[i])
                }
            }
            $(".js-marketing-add-lead-tag-dialog-title-id").html(self.editLeadId);
            $("#modal-marketing-add-lead-tag").modal('show');
        });
        // Detecta operador clicando para salvar as novas tags
        $(document).on('submit', '.js-update-mkt-lead-tags-form', function (e) {
            e.preventDefault();
            let mountLeadTags = [];

            try {
                let newLeadTags = JSON.parse($("#mkt-lead-add-tags").val());
                if (newLeadTags) {
                    for (let i in newLeadTags) {
                        let newTag = newLeadTags[i];
                        mountLeadTags.push(newTag.value);
                    }
                }
            } catch (err) {
                console.error('[ERROR] [js-update-mkt-lead-tags-form]', err)
            }

            // Verificar se a tag "atendido" está presente
            let hadAtendidoTag = false;
            if (self.editLeadInfo.TAGS) {
                let oldTags = self.editLeadInfo.TAGS.split(",");
                hadAtendidoTag = oldTags.some(tag => tag.toLowerCase() === 'atendido');
            }
            let hasAtendidoTag = mountLeadTags.some(tag => tag.toLowerCase() === 'atendido');

            if (hasAtendidoTag && !hadAtendidoTag) {
                // Armazenar tags pendentes e abrir modal de CPF
                self.pendingTagsUpdate = {
                    tags: mountLeadTags,
                    leadId: self.editLeadId,
                    leadInfo: self.editLeadInfo
                };
                $("#modal-marketing-add-lead-tag").modal('hide');
                $(".js-marketing-link-lead-cpf-dialog-title-id").html(self.editLeadId);
                $("#mkt-lead-cpf").val('');
                $("#modal-marketing-link-lead-cpf").modal('show');
                return;
            }

            if (hadAtendidoTag && !hasAtendidoTag) {
                return window.toast({
                    error: true,
                    text: "Não é possível remover a tag atendido."
                });
            }

            // Se não tem tag atendido, enviar normalmente
            if (self.ws) {
                $('.js-update-mkt-lead-tags-form').trigger('reset');
                $("#modal-marketing-add-lead-tag").modal('hide');
                self.ws.emit('data', {
                    cmd: 'updateLeadTags',
                    payload: {
                        userId: window._sessionData.userId,
                        ownerId: self.editLeadInfo.LEAD_DONO_ID,
                        id: self.editLeadId,
                        value: mountLeadTags,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
        });

        // Detecta operador clicando para abrir a janela de transferencia de lead
        $(document).on('click', '.js-lead-transfer', function (e) {
            e.preventDefault();
            self.editLeadId = $(this).data('lead-id');
            self.editLeadInfo = $(this).data('info');
            if (self.editLeadInfo.LEAD_DONO_ID === null)
                return window.toast({ error: true, text: "Este lead não possui nenhum Hunter como dono." });

            $(".js-marketing-transfer-lead-dialog-title-id").html(self.editLeadId);
            $("#mkt-lead-transfer-from").val(self.editLeadInfo.LEAD_DONO_ID);
            $("#modal-marketing-transfer-lead").modal('show');
        });
        // Detecta operador clicando para transferir dono do lead
        $(document).on('submit', '.js-update-mkt-lead-transfer-owner-form', function (e) {
            e.preventDefault();
            let data = $(this).serializeArray();
            let selectedNewHunter = $("#mkt-lead-transfer-to option:selected").val();
            if (self.ws) {
                $('.js-update-mkt-lead-transfer-owner-form').trigger('reset');
                $("#modal-marketing-transfer-lead").modal('hide');
                self.ws.emit('data', {
                    cmd: 'transferLead',
                    payload: {
                        userId: window._sessionData.userId,
                        ownerId: self.editLeadInfo.LEAD_DONO_ID,
                        id: self.editLeadId,
                        targetHunter: selectedNewHunter,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
        });

        // Detecta operador clicando para abrir a janela de desativação de lead
        $(document).on('click', '.js-lead-inactivate', function (e) {
            e.preventDefault();
            self.editLeadId = $(this).data('lead-id');
            self.editLeadInfo = $(this).data('info');
            $(".js-marketing-deactivate-lead-dialog-title-id").html(self.editLeadId);
            $("#modal-marketing-deactivate-lead").modal('show');
        });
        // Detecta operador clicando para desativar lead
        $(document).on('submit', '.js-update-mkt-lead-deactivate-form', function (e) {
            e.preventDefault();
            if (self.ws) {
                $('.js-update-mkt-lead-deactivate-form').trigger('reset');
                $("#modal-marketing-deactivate-lead").modal('hide');
                self.ws.emit('data', {
                    cmd: 'deactivateLead',
                    payload: {
                        userId: window._sessionData.userId,
                        ownerId: self.editLeadInfo.LEAD_DONO_ID,
                        id: self.editLeadId,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })
            }
        });

        // Handler para abrir modal de CPF - aplicar máscara
        $(document).on('shown.bs.modal', '#modal-marketing-link-lead-cpf', function () {
            $('.js-marketing-link-lead-cpf-dialog-title-patient-name-container').addClass('d-none');
            if ($('#mkt-lead-cpf').length && typeof $.fn.mask !== 'undefined') {
                $('#mkt-lead-cpf').mask('999.999.999-99', {
                    onComplete: function (txt) {
                        $('#mkt-lead-cpf').prop('disabled', true);
                        $(".modal-marketing-link-lead-cpf-dialog").block(window._loader.loading);
                        apiCall({
                            method: 'GET',
                            endpoint: 'api/v1/patient/search_document',
                            data: {
                                document_type: 'cpf',
                                document: txt,
                                is_lead_link: true
                            },
                            successCallback: function (res) {
                                $(".modal-marketing-link-lead-cpf-dialog").unblock();

                                window.toast({
                                    error: res.error,
                                    text: res.message
                                })

                                if (res.error) {
                                    $("#mkt-lead-cpf").val('');
                                    $("#mkt-lead-cpf").prop('disabled', false);
                                } else {
                                    $("#mkt-lead-cpf-patient-id").val(res.patientId);
                                    $('.js-marketing-link-lead-cpf-form').find('button[type="submit"]').prop('disabled', false);
                                    $('.js-marketing-link-lead-cpf-dialog-title-patient-name-container').removeClass('d-none');
                                    $('.js-marketing-link-lead-cpf-dialog-title-patient-name').text(res.patientName);
                                }
                            },
                            errorCallback: function (err) {
                                $(".modal-marketing-link-lead-cpf-dialog").block(window._loader.error);
                            }
                        });
                    }
                });
            }
        });

        // Handler para fechar modal de CPF
        $(document).on('click', '.js-marketing-link-lead-cpf-dialog-close', function () {
            $("#mkt-lead-cpf").val('');
            $("#mkt-lead-cpf-patient-id").val('');
            $("#mkt-lead-cpf").prop('disabled', false);
            $('.js-marketing-link-lead-cpf-form').find('button[type="submit"]').prop('disabled', true);
            $('.js-marketing-link-lead-cpf-dialog-title-patient-name-container').addClass('d-none');
            $("#modal-marketing-link-lead-cpf").modal('hide');

        });

        $(document).on('click', '.js-marketing-link-lead-cpf-dialog-clear-cpf', function () {
            $("#mkt-lead-cpf").val('');
            $("#mkt-lead-cpf-patient-id").val('');
            $("#mkt-lead-cpf").prop('disabled', false);
            $('.js-marketing-link-lead-cpf-form').find('button[type="submit"]').prop('disabled', true);
            $('.js-marketing-link-lead-cpf-dialog-title-patient-name-container').addClass('d-none');
        });

        // Handler para submit do modal de CPF
        $(document).on('submit', '.js-marketing-link-lead-cpf-form', function (e) {
            e.preventDefault();

            if (!self.pendingTagsUpdate) {
                window.toast({
                    error: true,
                    text: 'Erro: dados de tags não encontrados.'
                });
                $("#modal-marketing-link-lead-cpf").modal('hide');
                return;
            }

            let cpf = $('#mkt-lead-cpf').val();
            // Remover formatação do CPF
            cpf = cpf.replace(/[^0-9]/g, '');

            // Validar CPF básico (11 dígitos)
            if (cpf.length !== 11) {
                window.toast({
                    error: true,
                    text: 'CPF inválido. Deve conter 11 dígitos.'
                });
                return;
            }

            // Enviar tags + CPF ao socket.io
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'updateLeadTags',
                    payload: {
                        userId: window._sessionData.userId,
                        ownerId: self.pendingTagsUpdate.leadInfo.LEAD_DONO_ID,
                        id: self.pendingTagsUpdate.leadId,
                        value: self.pendingTagsUpdate.tags,
                        patientId: $('#mkt-lead-cpf-patient-id').val(),
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                });

                $('.js-marketing-link-lead-cpf-form').trigger('reset');
                $("#modal-marketing-link-lead-cpf").modal('hide');
                $('.js-update-mkt-lead-tags-form').trigger('reset');
                $("#mkt-lead-cpf").prop('disabled', false);
                $('.js-marketing-link-lead-cpf-dialog-title-patient-name-container').addClass('d-none');
                $('.js-marketing-link-lead-cpf-form').find('button[type="submit"]').prop('disabled', true);

                // Limpar dados pendentes
                self.pendingTagsUpdate = null;
            }
        });

        // Detecta operador tentando realizar busca
        $(document).on('change', '#mktLeadSearch', function () {
            let searchValue = $(this).val();
            if (self.viewMode === 'table') {
                $(".js-leads-table").block(window._loader.loading);
            } else {
                $(".js-leads-kanban-container").block(window._loader.loading);
            }
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'searchLead',
                    payload: {
                        userId: window._sessionData.userId,
                        ownerId: self.editLeadInfo ? self.editLeadInfo.LEAD_DONO_ID : null,
                        search: searchValue,
                        pagination: {
                            page: self.tableHandler.getCurrentPage(),
                            recordsPerPage: parseInt($('.js-filter-leads-per-page').val()),
                            filter: JSON.stringify(self.tableHandler.getCurrentFilters())
                        }
                    }
                })

                self.getTotalLeads({
                    createInterval: false
                })
            }
            // Se estiver no modo kanban, recarregar
            if (self.viewMode === 'kanban') {
                self.renderKanbanView();
            }
        });

        $(document).on('change', '#mktLeadAllowedRoles', function () {
            if (self.viewMode === 'table') {
                $(".js-leads-table").block(window._loader.loading);
            } else {
                $(".js-leads-kanban-container").block(window._loader.loading);
            }
            if (self.ws) {
                self.ws.emit('data', {
                    cmd: 'filterByAllowedRoles',
                    payload: {
                        userId: window._sessionData.userId,
                        name: $('#mktLeadAllowedRoles').val()
                    }
                })
            }
            // Se estiver no modo kanban, recarregar
            if (self.viewMode === 'kanban') {
                self.renderKanbanView();
            }
        });

        // Detecta operador administrador clicando para exportar leads de uma Filial
        $(document).on('click', '.js-leads-database-export-btn', function () {
            let branchId = $(this).data('branch-id');
            if (branchId != '-- Selecione --') {
                apiCall({
                    method: 'POST',
                    endpoint: `api/v1/marketing/export-leads`,
                    data: {
                        branchId: branchId,
                        startDate: $('.js-filter-leads-export-start-date').val(),
                        endDate: $('.js-filter-leads-export-end-date').val(),
                        allowedRoles: $('#mktLeadAllowedRoles').val()
                    },
                    successCallback: function (res) {
                        if (!res.error) {
                            const worksheet = XLSX.utils.json_to_sheet(res.data);

                            // Create a workbook and add the worksheet to it
                            const workbook = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                            // Export the workbook to an Excel file
                            XLSX.writeFile(workbook, 'relatorio_leads_' + window.getSaoPauloDateTime() + '_' + $(".js-leads-list-branches-selector option:selected").text() + '.xlsx');

                            window.toast({
                                error: false,
                                text: "Exportação realizada com sucesso."
                            })
                        } else {
                            window.toast({
                                error: res.error,
                                text: res.message
                            })
                        }
                    },
                    errorCallback: function () {
                        $(".js-leads-table").unblock();
                    }
                });
            }

        });

        // Detecta clique para mudar modo de visualização dos dados CRm
        $(document).on('click', 'input[name="mode"]:checked', function () {
            self.crmMode = $(this).val();
            self.getTotalLeads({
                createInterval: false
            })
        });

        $(document).on('click', '#crm-view-date-btn', function () {
            self.ws.emit('data', {
                cmd: 'getTotalLeadsFiltered',
                payload: {
                    userId: window._sessionData.userId,
                    branchId: self.branchFilter,
                    startDate: moment($('#crm-date-start').val() + ' 00:00:00').tz('America/Sao_Paulo').unix(),
                    endDate: moment($('#crm-date-end').val() + ' 23:59:59').tz('America/Sao_Paulo').unix(),
                }
            })

            $('#crm-date-data-leads-clinica').html('Carregando...');
            $('#crm-date-data-leads-sdr').html('Carregando...');
            $('#crm-date-data-leads-geral').html('Carregando...');
        });

        $(document).on('change', '#js-only-franchise', function () {
            self.onlyFranchise = $(this).is(':checked');
            let allowedBranches = window._sessionData.businessBranches.map((branch) => {
                if (!self.deps.userHasRole('ADMIN') && self.deps.userHasRole('MANAGER'))
                    return branch.ID;
                if (self.deps.userHasRole('ADMIN') && self.onlyFranchise && branch.FRANQUIADO == 1)
                    return branch.ID;
                if (self.deps.userHasRole('ADMIN') && !self.onlyFranchise && branch.FRANQUIADO == 0)
                    return branch.ID;
                return false;
            }).filter((branch) => branch !== false);

            self.ws.emit('data', {
                cmd: 'updateAllowedBranches',
                payload: {
                    businessBranches: self.businessBranches,
                    updateAllowedBranches: allowedBranches,
                    isKanbanView: self.viewMode === 'kanban',
                }
            })
        });
    }

    updateLeadInKanban(leadData, oldTags) {
        let self = this;

        if (!leadData || leadData.ATIVO != 1) {
            // Se lead foi desativado, remover de todas as colunas
            $('.kanban-card[data-lead-id="' + leadData.ID + '"]').remove();
            return;
        }

        // Obter tags novas (sempre usar TAGS pois mountLeadCard usa lead.TAGS)
        let newTags = leadData.TAGS || '';
        let newTagsArray = newTags ? newTags.split(',').map(t => t.trim()).filter(t => t) : [];

        // Obter tags antigas
        let oldTagsArray = (oldTags && oldTags !== 'null' && oldTags !== '') ? oldTags.split(',').map(t => t.trim()).filter(t => t) : [];

        console.log('[updateLeadInKanban] Lead ID:', leadData.ID, 'Old Tags:', oldTags, 'New Tags:', newTags);

        // Remover o card de todas as colunas onde estava antes
        $('.kanban-card[data-lead-id="' + leadData.ID + '"]').remove();

        // Se não tem tags, adicionar na coluna "Sem Tags"
        if (newTagsArray.length === 0) {
            let noTagColumn = '[data-tag-column=""]';
            if ($(noTagColumn).length > 0) {
                // Criar novo card HTML para esta coluna
                let cardHtml = self.mountLeadCard(leadData, {
                    locked: false
                });
                // Adicionar antes do botão "Carregar mais" se existir (botão está dentro do data-tag-column)
                let loadMoreBtn = $(noTagColumn).find('[data-load-more-column=""]');
                /*if (loadMoreBtn.length > 0) {
                    loadMoreBtn.before(cardHtml);
                } else {*/
                $(noTagColumn).prepend(cardHtml);
                //}
                console.log('[updateLeadInKanban] Adicionado na coluna "Sem Tags"');
            } else {
                console.log('[updateLeadInKanban] Coluna "Sem Tags" não encontrada');
            }
        } else {
            // Adicionar o card em cada coluna correspondente às novas tags
            for (let i in newTagsArray) {
                let tag = newTagsArray[i];
                let tagColumn = '[data-tag-column="' + tag + '"]';

                if ($(tagColumn).length > 0) {
                    // Criar novo card HTML para cada coluna (cada coluna precisa de seu próprio elemento DOM)
                    let cardHtml = self.mountLeadCard(leadData, {
                        locked: false
                    });

                    // Adicionar antes do botão "Carregar mais" se existir (botão está dentro do data-tag-column)
                    let loadMoreBtn = $(tagColumn).find('[data-load-more-column="' + tag + '"]');
                    if (loadMoreBtn.length > 0) {
                        loadMoreBtn.before(cardHtml);
                    } else {
                        $(tagColumn).prepend(cardHtml);
                    }
                    console.log('[updateLeadInKanban] Adicionado na coluna:', tag);
                } else {
                    console.log('[updateLeadInKanban] Coluna não encontrada:', tag);
                }
            }
        }
    }

    blockAllButtons() {
        $('.js-lead-contact').each(function () {
            $(this).prop('disabled', true);
        });
    }

    unblockAllButtons() {
        $('.js-lead-contact').each(function () {
            $(this).prop('disabled', false);
        });
    }

    openNewTab(url) {
        var newTab = window.open(url, '_blank');
        newTab.focus();
    }

    copyToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            console.log('Text copied to clipboard');
        } catch (err) {
            console.error('Unable to copy to clipboard:', err);
        } finally {
            document.body.removeChild(textarea);
        }
    }
}